<template>
  <div class="container">
    <div class="menu" role="menu">
      <ul>
        <li>
          <router-link to="/">bioplan architekten</router-link>
        </li>
      </ul>
      <ul>
        <li>
          <router-link :to="{ name: 'Archive' }">archiv</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Office' }" class="active">büro</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Contact' }">contact</router-link>
        </li>
      </ul>
    </div>

    <div class="content">
      <LoadingSpinner v-if="isLoading"></LoadingSpinner>
      <template v-else>
        <div class="left font-regular" v-html="textHtml"></div>
        <div class="right">
          <div class="img-container" v-if="!loadingPeople">
            <div class="person" v-for="p in people" :style="`color: ${p.color}`">
              <img :src="p.url" />
              <div class="name font-medium">
                {{ p.name }}
              </div>
              <div class="title">
                {{ p.title }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="information">
      <img src="../../assets/img/bioplan_signet.png" height="57" width="72" class="signet" />
    </div>
  </div>
</template>

<script>
  import LoadingSpinner from '../parts/LoadingSpinner'
  import rest from '../../services/rest'
  import marked from 'marked'

  export default {
    name: 'Office',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        people: [],
        loadingPeople: true,
        loadingText: true,
        text: ''
      }
    },
    computed: {
      isLoading () {
        return this.loadingPeople || this.loadingText
      },
      textHtml () {
        return marked(this.text, { sanitize: true, breaks: true })
      }
    },
    methods: {
      loadPeople () {
        this.loadingPeople = true

        rest.persons.all((response, hasError) => {
          if (hasError) { return }
          this.people = response.data
          this.loadingPeople = false
        })
      },
      loadText () {
        this.loadingText = true
        rest.pages.byName('office', (response, hasError) => {
          if (hasError) {
            this.loadingText = false
            return
          }
          this.text = response.body.content
          this.loadingText = false
        })
      }
    },
    mounted () {
      this.loadPeople()
      this.loadText()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    padding: 25px;
  }
  .content {
    margin-bottom: 77px;
    padding: 25px 0 0 0;
    color: white;
  }
  .content::after {
    content:"";
    display:block;
    clear:both;
  }
  .left {
    float: left;
    width: calc((100% - 75px) / 4 - 25px);
  }
  .right {
    float: right;
    width: calc(100% - ((100% - 75px) / 4));
    padding-top: 10px;
  }
  @media (max-width: 1199px) {
    .left {
      width: calc(100% / 3 - 25px);
    }
    .right {
      width: calc(100% / 3 * 2);
    }
  }
  .left a {
    color: white;
    text-decoration: none;
  }
  .right .map {
    width: 100%;
  }
  .img-container::after {
    content:"";
    display:block;
    clear:both;
  }
  .person {
    float: left;
    padding-bottom: 50px;
    padding-left: 25px;
    width: calc(100% - 25px);
  }
  .person .title {
    font-family: 'bioregular';
  }
  /** Breite:
   * Nicht unter 250px + 25px Rand links je Bild
   * Zusätzlich benötigt: 375px
   * - 50px (je 25px Rand links/rechts)
   * - 325px (für linken Bereich)
   *
   * Ergebnis:
   * 4 Bilder ab: 1475px
   * 3 Bilder ab: 1200px
   * 2 Bilder ab: 925px
   **/
  @media (min-width: 925px) {
    .person {
      width: calc((100% - 2 * 25px) / 2);
    }
  }
  @media (min-width: 1200px) {
    .person {
      width: calc((100% - 3 * 25px) / 3);
    }
  }
  @media (min-width: 1475px) {
    .person {
      width: calc((100% - 4 * 25px) / 4);
    }
  }
  @media (max-width: 655px) {
    .person {
      padding-left: 0;
      width: 100%;
    }
  }
  .person:not(:hover) div {
    color: white;
  }
  .person img {
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
    z-index: 9000;
    margin-bottom: 5px;
    width: 100%;
  }
  .person img:hover {
    -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
    filter: grayscale(0%);
  }
  @media (max-width: 655px) {
    .left, .right {
      float: none;
      width: 100%;
      max-width: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Office.vue?51988734